<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-layout column >
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="[
                      'btnRetrieve',
                    ]"
                    @btnRetrieve="btnRetrieve"
                  >
                    <template v-slot:body>
                      <v-row>
                        <v-col cols="12">
                        </v-col>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <v-row no-gutters>
                    <v-col cols="12" align="right" class="pr-2 vat">( Included V.A.T )</v-col>
                  </v-row>
                  <DxDataGrid id="epms4020" 
                    class="hipGridHeight1" 
                    :ref="epms4020Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    @cellPrepared="cellPrepared"
                  >
                    <DxColumn data-field="poDte" caption="PO Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="poNo" caption="PO No" width="10%" data-type="string" alignment="center" :allow-editing="false" cell-template="poNoTemplate" />
                      <template #poNoTemplate="{ data }">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn" @click="successDetail(data)" >
                          {{data.text}}
                        </v-btn>
                      </template>
                    <DxColumn data-field="quotNo" caption="Quotation No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="quotTitle" caption="Item" width="20%" data-type="string" alignment="left" :allow-editing="false" cell-template="quotTitleTemplate" />
                      <template #quotTitleTemplate="{ data }">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn" @click="successDetail(data)" >
                          {{data.text}}
                        </v-btn>
                      </template>
                    <DxColumn data-field="buyerNm" caption="Purchase Charger" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="poAmt" caption="PO Amount" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="moneUnit" caption="Money Unit" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="transFee" caption="Trans. Fee" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="govFee" caption="Gov. Fee" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxPaging :enabled="true" :page-size="30" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn  } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getSuccessList } from '@/api/view/hip/4/epms4020.js'

export default {
  name: 'epms4020',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      epms4020Ref: 'epms4020Ref',
      gridMainList: [],
      
      //cell merge
      mergeElements: [],
      mergeStartElements: [],

      nonDispalyedRowIndex: [],
      curRowIndex: 0

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms4020Ref)
    },
  },
  mounted() {
    this.doSearchMain()
  },
  methods: {
    async doSearchMain(){
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
      }
      await getSuccessList(params).then(res => {
        if(res.list.length){
          res.list.forEach(e => {
            e.id = e.rnum
          });
          this.gridMainList = res.list
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '1px'
      }
    },
    btnRetrieve(){
      this.doSearchMain()
    },
    successDetail(e){
      this.$router.push({name: 'epms4030' , params:{poNo: e.values[1]}});
    }
  }
}
</script>
<style scoped>
  .vat {
    color: blue;
  }
  .receiptBtn {
    font-weight: bold;
  }
  .receiptBtn:hover {
    color: #4980BC;
  }

</style>